import { defaultPageInfo, IPageInfo } from '../../models/page.types';
import { SessionSortBy } from '../../models/sessionListItem.types';
import { CardsSortBy } from '../../models/solutionCard.types';
import { AssessmentSortBy, Filters } from '../../pages/Assessment/Assessment.types';
import { AdvanceFilter } from '../../pages/Assessment/Modals/AdvancedFilter/AdvanceFilter.types';
import { ExamineeListSortBy, ExamineeResponse } from '../../pages/ExamineeList/ExamineeList.types';
import {
  AdvancedFilterBodyAssessment,
  SampleAssessmentSortBy,
} from '../../pages/SampleAssessment/SampleAssessment.types';
import { ExaminersSortBy, UsersSortBy } from '../../pages/Users/Users.types';
import { ExamTaskGroupSolutionsResponse } from '../../services/exams/assessmentSession/assessments.types';

export enum DataInfoType {
  UserInfo = 'userInfo',
  ExaminersInfo = 'examinersInfo',
  CardsInfo = 'cardsInfo',
  SessionsInfo = 'sessionsInfo',
  ExamineesInfo = 'examineesInfo',
  AssessmentTrainingInfo = 'assessmentTrainingInfo',
  AssessmentQualificationInfo = 'assessmentQualificationInfo',
  AssessmentScoringInfo = 'assessmentScoringInfo',
  AssessmentControlInfo = 'assessmentControlInfo',
  SampleAssessment = 'sampleAssessmentInfo',
}

// Users
export type UsersDataInfo = {
  filterData: UsersFilterInfo;
};

export type UsersFilter = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  pesel: string;
  accountTypeName: string[];
  examCommittee: string[];
  accountStatus: string[];
  status: string[];
};

export type UsersSort = {
  isDescending: boolean;
  sortByColumnId: UsersSortBy | ExaminersSortBy;
};

export type UsersFilterInfo = {
  filter: UsersFilter;
  sort: UsersSort;
  pageInfo: IPageInfo;
};

export type FirstLoadGurad = {
  userInfo: boolean;
  examinersInfo: boolean;
};

export const defaultUsersFilter: UsersFilter = {
  firstName: '',
  lastName: '',
  email: '',
  pesel: '',
  phone: '',
  accountTypeName: [],
  examCommittee: [],
  accountStatus: [],
  status: [],
};

export const defaultUsersSort: UsersSort = {
  isDescending: false,
  sortByColumnId: 'lastName',
};

export const defaultUsersInfo: UsersDataInfo = {
  filterData: { filter: defaultUsersFilter, pageInfo: defaultPageInfo, sort: defaultUsersSort },
};
// Users

// Cards
export type CardsFilterInfo = {
  filter: CardsFilter;
  sort: CardsSort;
  pageInfo: IPageInfo;
};

export type CardsDataInfo = {
  filterData: CardsFilterInfo;
};

export type CardsFilter = {
  tasksSolutionSheetId: string;
  bundleNumber: string;
  bundleName: string;
  bundleSheetCode: string;
  examCommitteeId: string[];
  schoolCode: string;
  examineeIdentity: string;
  bundleImportFrom: string;
  bundleImportTo: string;
  processingDateFrom: string;
  processingDateTo: string;
  status: string[];
};

export type CardsSort = {
  isDescending: boolean;
  sortByColumnId: CardsSortBy;
};
export const defaultCardFilter: CardsFilter = {
  tasksSolutionSheetId: '',
  bundleNumber: '',
  bundleName: '',
  bundleSheetCode: '',
  examCommitteeId: [],
  schoolCode: '',
  examineeIdentity: '',
  bundleImportFrom: '',
  bundleImportTo: '',
  processingDateFrom: '',
  processingDateTo: '',
  status: [],
};

export const defaultCardsSort: CardsSort = {
  isDescending: true,
  sortByColumnId: 'bundleImportDate',
};

export const defaultCardsInfo: CardsDataInfo = {
  filterData: { filter: defaultCardFilter, pageInfo: defaultPageInfo, sort: defaultCardsSort },
};
// Cards

// Sessions
export type SessionsFilterInfo = {
  filter: SessionsFilter;
  sort: SessionsSort;
  pageInfo: IPageInfo;
};

export type SessionsDataInfo = {
  filterData: SessionsFilterInfo;
};

export type SessionsFilter = {
  sessionName: string;
  examType: string;
  subject: string;
  isConfigured: string[];
  sheetCode: string;
  year: string;
  month: string[];
  sourceSystemType: string[];
  archiveFrom: string;
  archiveTo: string;
  state: string[];
};

export type SessionsSort = {
  isDescending: boolean;
  sortByColumnId: SessionSortBy;
};
export const defaultSessionsFilter: SessionsFilter = {
  sessionName: '',
  examType: '',
  subject: '',
  isConfigured: [],
  sheetCode: '',
  year: '',
  month: [],
  sourceSystemType: [],
  archiveFrom: '',
  archiveTo: '',
  state: [],
};

export const defaultSessionsSort: SessionsSort = {
  isDescending: true,
  sortByColumnId: 'year',
};

export const defaultSessionsInfo: SessionsDataInfo = {
  filterData: { filter: defaultSessionsFilter, pageInfo: defaultPageInfo, sort: defaultSessionsSort },
};
// Sessions

// Examinees

export type ExamineesFilterInfo = {
  filter: ExamineesFilter;
  rawData: ExamineeResponse | undefined;
  sort: ExamineesSort;
  pageInfo: IPageInfo;
};

export type ExamineesDataInfo = {
  filterData: ExamineesFilterInfo;
};

export type ExamineesFilter = {
  examCommittee: string[];
  schoolCode: string;
  examineeCode: string;
  examineePesel: string;
  examName: string;
  sheetCode: string; //sheetCodeParam ?? '',
  room: string;
  importDateFrom: string;
  importDateTo: string;
  status: string[];
  adjustments: string[];
  adjustmentTypes: string[];
  adjustmentPermissions: string[];
};

export type ExamineesSort = {
  isDescending: boolean;
  sortByColumnId: ExamineeListSortBy;
};
export const defaultExamineesFilter: ExamineesFilter = {
  examCommittee: [],
  schoolCode: '',
  examineeCode: '',
  examineePesel: '',
  examName: '',
  sheetCode: '', //sheetCodeParam ?? '',
  room: '',
  importDateFrom: '',
  importDateTo: '',
  status: [],
  adjustments: [],
  adjustmentTypes: [],
  adjustmentPermissions: [],
};

export const defaultExamineesSort: ExamineesSort = {
  isDescending: true,
  sortByColumnId: 'importDate',
};

export const defaultExamineesInfo: ExamineesDataInfo = {
  filterData: {
    filter: defaultExamineesFilter,
    pageInfo: defaultPageInfo,
    sort: defaultExamineesSort,
    rawData: undefined,
  },
};
// Examinees

// Assessment

export type AssessmentFilterInfo = {
  filter: Filters;
  advancedFilter: AdvanceFilter | null;
  advancedFilterBody: AdvancedFilterBodyAssessment[];
  rawData: ExamTaskGroupSolutionsResponse | null | undefined;
  sort: AssessmentSort;
  pageInfo: IPageInfo;
};

export type AssessmentDataInfo = {
  filterData: AssessmentFilterInfo;
};

export type AssessmentSort = {
  isDescending: boolean;
  sortByColumnId: AssessmentSortBy;
};
export const defaultAssessmentFilter: Filters = {
  flag: [],
  examTaskGroupSolutionScoreId: '', //searchParams?.get('examTaskGroupSolutionScoreId') || '',
  status: [],
  pointsFrom: '',
  pointsTo: '',
  progress: '',
  alerts: [],
  downloadDateFrom: '',
  downloadDateTo: '',
  updateDateFrom: '',
  updateDateTo: '',
  assessmentQualityId: [],
  examinerName: '', //searchParams?.get('examinerName') || '',
  examTaskNumbersWithNoAnswer: '',
};

export const defaultAssessmentSort: AssessmentSort = {
  isDescending: true,
  sortByColumnId: 'downloadDate',
};

export const defaultAssessmentInfo: AssessmentDataInfo = {
  filterData: {
    filter: defaultAssessmentFilter,
    pageInfo: defaultPageInfo,
    sort: defaultAssessmentSort,
    rawData: null,
    advancedFilter: null,
    advancedFilterBody: [],
  },
};
// Assessment

// SampleAssessment
export type SampleAssessmentFilterInfo = {
  filter: SampleAssessmentFilter;
  advancedFilter: AdvanceFilter | null;
  advancedFilterBody: AdvancedFilterBodyAssessment[];
  sort: SampleAssessmentSort;
  pageInfo: IPageInfo;
};

export type SampleAssessmentDataInfo = {
  filterData: SampleAssessmentFilterInfo;
};

export type SampleAssessmentSort = {
  isDescending: boolean;
  sortByColumnId: SampleAssessmentSortBy;
};

export type SampleAssessmentFilter = {
  firstName: string;
  lastName: string;
  examTaskGroupSolutionScoreId: string;
  schoolId: string;
  processType: string[];
  pointSumFrom: string;
  pointSumTo: string;
  progress: string[];
  acceptanceStatus: string[];
  updateDateFrom: string;
  updateDateTo: string;
  alerts: string[];
  examTaskNumbersWithNoAnswer: string;
};

export const defaultSampleAssessmentFilter: SampleAssessmentFilter = {
  firstName: '',
  lastName: '',
  examTaskGroupSolutionScoreId: '',
  schoolId: '',
  processType: [],
  pointSumFrom: '',
  pointSumTo: '',
  progress: [],
  acceptanceStatus: [],
  updateDateFrom: '',
  updateDateTo: '',
  alerts: [],
  examTaskNumbersWithNoAnswer: '',
};

export const defaultSampleAssessmentSort: SampleAssessmentSort = {
  isDescending: true,
  sortByColumnId: 'schoolId',
};

export const defaultSampleAssessmentInfo: SampleAssessmentDataInfo = {
  filterData: {
    filter: defaultSampleAssessmentFilter,
    pageInfo: defaultPageInfo,
    sort: defaultSampleAssessmentSort,
    advancedFilterBody: [],
    advancedFilter: null,
  },
};
// SampleAssessment

// Guards
export type FilterUpdateGuard = {
  [DataInfoType.UserInfo]: DeepPartial<UsersFilterInfo>;
  [DataInfoType.ExaminersInfo]: DeepPartial<UsersFilterInfo>;
  [DataInfoType.CardsInfo]: DeepPartial<CardsFilterInfo>;
  [DataInfoType.SessionsInfo]: DeepPartial<SessionsFilterInfo>;
  [DataInfoType.ExamineesInfo]: DeepPartial<ExamineesFilterInfo>;
  [DataInfoType.AssessmentTrainingInfo]: DeepPartial<AssessmentFilterInfo>;
  [DataInfoType.AssessmentControlInfo]: DeepPartial<AssessmentFilterInfo>;
  [DataInfoType.AssessmentQualificationInfo]: DeepPartial<AssessmentFilterInfo>;
  [DataInfoType.AssessmentScoringInfo]: DeepPartial<AssessmentFilterInfo>;
  [DataInfoType.SampleAssessment]: DeepPartial<SampleAssessmentFilterInfo>;
};

export type FilterUpdateMap = {
  [K in keyof FilterUpdateGuard]: {
    filterType: K;
    newValues: FilterUpdateGuard[K];
  };
};

export type FilterUpdate = FilterUpdateMap[keyof FilterUpdateGuard];
// Guards

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;
